// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '@shared/commons/DataCache';
import { ExternalLinkType } from '@shared/commons/cache/ExternalLink/Branding/ExternalLinkType';
class ExternalLinkManager {
    getExternalMenu(externalMenu, tool) {
        var _a;
        if (externalMenu === null || tool === null) {
            return null;
        }
        for (const menuIt of externalMenu) {
            const text = menuIt.text;
            const clientTab = tool.clientTab;
            const alliaseTabName = (_a = tool.getLocalizedTabNameOrNull()) !== null && _a !== void 0 ? _a : '';
            const hasAlliaseTabName = alliaseTabName !== '';
            const tabMatch = text === clientTab;
            const aliasMatch = text === alliaseTabName;
            if ((hasAlliaseTabName && aliasMatch) || (!hasAlliaseTabName && tabMatch)) {
                return menuIt;
            }
        }
        return null;
    }
    getWMLinks() {
        const allowedLinkTypes = [
            ExternalLinkType.NONE,
            ExternalLinkType.LINK_TOKEN_LANG,
            ExternalLinkType.WEB_CONTAINER,
            ExternalLinkType.TOKEN_POST
        ];
        return this.getLinks(allowedLinkTypes);
    }
    getYoutubeLinks() {
        return DataCache.ExternalLinksCache.getYoutubeExtLinks();
    }
    getLinks(linkTypes = []) {
        const filteredLinks = [];
        const tools = DataCache.ExternalLinksCache.getExtLinks();
        for (const tool of tools) {
            if (!isNullOrUndefined(tool) &&
                (linkTypes.length === 0 || linkTypes.includes(tool.brandingToolExtResource))) {
                filteredLinks.push(tool);
            }
        }
        const groupedLinks = this.groupBy(filteredLinks, (link) => link.brandingToolExtResource);
        const sortedLinks = [];
        for (const linkType of Object.keys(groupedLinks)) {
            const linksOfType = groupedLinks[linkType].sort((a, b) => a.id - b.id);
            sortedLinks.push(...linksOfType);
        }
        return sortedLinks;
    }
    groupBy(array, keyGetter) {
        return array.reduce((result, currentItem) => {
            const key = keyGetter(currentItem);
            if (!result[key]) {
                result[key] = [];
            }
            result[key].push(currentItem);
            return result;
        }, {});
    }
    isTabLink(link) {
        const type = link.brandingToolExtResource;
        const extTypesAllowTab = [
            ExternalLinkType.NONE,
            ExternalLinkType.LINK_TOKEN_LANG,
            ExternalLinkType.AUTOCHARTIST_IFRAME,
            ExternalLinkType.WEB_CONTAINER,
            ExternalLinkType.TOKEN_POST
        ];
        const allowTabChoise = extTypesAllowTab.includes(type);
        return allowTabChoise;
    }
}
export const externalLinkManager = new ExternalLinkManager();
